<template>
  <div>
    <b-menu-list :label="$t('compScenarioDocsMenu.label-1')">
      <b-menu-item
        :active="
          buffer === 'scenario-notes' ||
          buffer === 'scenario-data' ||
          buffer === 'scenario-manual'
        "
        :expanded="
          buffer === 'scenario-notes' ||
          buffer === 'scenario-data' ||
          buffer === 'scenario-manual'
        "
        @click="activate('scenario-notes')"
      >
        <template slot="label" slot-scope="props">
          <b-icon icon="life-ring"></b-icon>
          {{ $t('compScenarioDocsMenu.label-2') }}
          <b-icon
            class="is-pulled-right"
            :icon="props.expanded ? 'caret-down' : 'caret-up'"
          >
          </b-icon>
        </template>
        <b-menu-item
          :active="buffer === 'scenario-notes'"
          @click="activate('scenario-notes')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="warning"></b-icon>
                  {{ $t('compScenarioDocsMenu.label-3') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          :active="buffer === 'scenario-data'"
          @click="activate('scenario-data')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="table"></b-icon>
                  {{ $t('compScenarioDocsMenu.label-5') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          :active="buffer === 'scenario-manual'"
          @click="activate('scenario-manual')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="book"></b-icon>
                  {{ $t('compScenarioDocsMenu.label-4') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
      </b-menu-item>
      <!-- <b-menu-item
        :active="buffer === 'scenario-team' || buffer === 'scenario-thanks'"
        :expanded="buffer === 'scenario-team' || buffer === 'scenario-thanks'"
        @click="activate('scenario-team')"
      >
        <template slot="label" slot-scope="props">
          <b-icon icon="users"></b-icon>
          <span v-html="$t('compScenarioDocsMenu.label-6')" />
          <b-icon
            class="is-pulled-right"
            :icon="props.expanded ? 'caret-down' : 'caret-up'"
          >
          </b-icon>
        </template>
        <b-menu-item
          :active="buffer === 'scenario-team'"
          @click="activate('scenario-team')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="keyboard-o"></b-icon>
                  {{ $t('compScenarioDocsMenu.label-7') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          :active="buffer === 'scenario-thanks'"
          @click="activate('scenario-thanks')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="thumbs-o-up"></b-icon>
                  {{ $t('compScenarioDocsMenu.label-8') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
      </b-menu-item> -->
    </b-menu-list>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      buffer: this.value
    }
  },
  watch: {
    value: function () {
      this.buffer = this.value
    }
  },
  methods: {
    activate: function (val) {
      this.buffer = val
      this.$emit('input', this.buffer)
    }
  }
}
</script>
